import React from 'react';
import PostInfoInjector from '../PostInfoInjector';

const PostCategoryViewer = ({ postInfo, isMiddle = false, isLeaf = false }) => {
    let category = '';
    if (postInfo) {
        if (
            postInfo.data &&
            postInfo.data.tags &&
            postInfo.data.tags.PostCategoryTag
        ) {
            const postCategoryTag = postInfo.data.tags.PostCategoryTag;
            if (postCategoryTag.top) {
                category = postCategoryTag.top;
                if (isMiddle && postCategoryTag.middle) {
                    category = category.concat('>', postCategoryTag.middle);
                    if (
                        isLeaf &&
                        postCategoryTag.leaf &&
                        Array.isArray(postCategoryTag.leaf)
                    ) {
                        postCategoryTag.leaf.forEach((value, idx) => {
                            category = category.concat(
                                idx === 0 ? '>' : ',',
                                value
                            );
                        });
                    }
                }
            }
        }
    }

    return <span>{category}</span>;
};

export default PostInfoInjector()(PostCategoryViewer);
